var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { setT } from 'helpers/translationUtilities';
import { Link } from 'react-router-dom';
import { generatePathWithParams } from 'components/routers/router';
import { ADMIN_PATHS } from 'components/routers/constants';
ViewSingleTemplateTasks.propTypes = {
    template: PropTypes.object,
    getGameTasks: PropTypes.func.isRequired
};
export default function ViewSingleTemplateTasks(_a) {
    var template = _a.template, getGameTasks = _a.getGameTasks;
    var _b = useState([]), tasks = _b[0], setTasks = _b[1];
    useEffect(function () {
        function fetchData() {
            return __awaiter(this, void 0, void 0, function () {
                var tasks_1, e_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, getGameTasks(template._id).then(function (response) { return response.message; })];
                        case 1:
                            tasks_1 = _a.sent();
                            setTasks(tasks_1);
                            return [3 /*break*/, 3];
                        case 2:
                            e_1 = _a.sent();
                            console.error(e_1);
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        }
        fetchData();
    }, [template]);
    var getTemplateTaskCompanies = function (task) {
        return template.companies.filter(function (item) { return task.address.companyIds.includes(item._id); });
    };
    var getTemplateTaskStages = function (task) {
        return template.stages.filter(function (item) { return task.stages.includes(item._id); });
    };
    return (React.createElement("div", null,
        React.createElement("div", { style: { margin: '1em 0', textAlign: 'right' } },
            React.createElement(Link, { to: generatePathWithParams(ADMIN_PATHS.TEMPLATE_TASK, { id: template._id, taskId: 'new' }) }, "Create new task")),
        React.createElement("table", { className: "admin-table" },
            React.createElement("thead", null,
                React.createElement("tr", { style: { textAlign: 'left' } },
                    React.createElement("th", null, "Task title"),
                    React.createElement("th", null, "Type"),
                    React.createElement("th", null, "Skip"),
                    React.createElement("th", null, "Stage/Order"),
                    React.createElement("th", null, "Address"),
                    React.createElement("th", null))),
            React.createElement("tbody", null, tasks.map(function (item, index) {
                var companies = getTemplateTaskCompanies(item);
                var stages = getTemplateTaskStages(item);
                return (React.createElement("tr", { key: index },
                    React.createElement("td", null, item.reference.name[0].value),
                    React.createElement("td", null, item.address.target),
                    React.createElement("td", null, item.skippable ? 'Yes' : ''),
                    React.createElement("td", null,
                        stages.map(function (item) { return (item.title[0].value); }).join(', '),
                        item.order ? " / ".concat(item.order) : null),
                    React.createElement("td", null, companies.map(function (item) { return (item.name[0].value); }).join(', ')),
                    React.createElement("td", null,
                        React.createElement(Link, { to: generatePathWithParams(ADMIN_PATHS.TEMPLATE_TASK, {
                                id: template._id,
                                taskId: item._id
                            }) }, setT('Edit')))));
            })))));
}
;
